import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { 
    GetLeaveDetails, 
    ManageLeave, 
    ManageLeaveRequest,
    LeaveRecord 
} from "../Leave/LeaveAction";
import LeavePopup from "../Leave/LeavePopup";


const globalStyles = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&display=swap');

  @keyframes shimmer {
    0%   { background-position: -200% center; }
    100% { background-position:  200% center; }
  }
  @keyframes fadeSlideUp {
    from { opacity: 0; transform: translateY(16px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes orbPulse1 {
    0%,100% { transform: scale(1) translate(0,0); opacity:.45; }
    50%     { transform: scale(1.1) translate(20px,-15px); opacity:.65; }
  }
  @keyframes orbPulse2 {
    0%,100% { transform: scale(1) translate(0,0); opacity:.35; }
    50%     { transform: scale(1.07) translate(-20px,15px); opacity:.55; }
  }
  @keyframes cardIn {
    from { opacity:0; transform: translateY(20px) scale(.98); }
    to   { opacity:1; transform: translateY(0) scale(1); }
  }
  @keyframes particle {
    0%   { transform: translateY(0) translateX(0); opacity:0; }
    10%  { opacity:.8; }
    90%  { opacity:.3; }
    100% { transform: translateY(-110vh) translateX(var(--dx)); opacity:0; }
  }
  .lm-particle {
    position: fixed;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(0,220,210,.8) 0%, rgba(0,160,190,.3) 60%, transparent 100%);
    animation: particle var(--dur) var(--delay) ease-in infinite;
    pointer-events: none;
    z-index: 0;
  }
  .lm-page {
    font-family: 'DM Sans', sans-serif;
    min-height: 100vh;
    background: linear-gradient(145deg,#04111a 0%,#091e2e 35%,#0d2840 60%,#06141e 100%);
    position: relative;
    overflow-x: hidden;
    color: #e8f4f6;
  }
  .lm-grid-bg {
    position: fixed;
    inset: 0;
    pointer-events: none;
    background-image:
      linear-gradient(rgba(0,210,200,.025) 1px, transparent 1px),
      linear-gradient(90deg, rgba(0,210,200,.025) 1px, transparent 1px);
    background-size: 55px 55px;
    z-index: 0;
  }
  .lm-content {
    position: relative;
    z-index: 1;
    padding: 12px 12px 24px;
  }
  .lm-breadcrumb {
    padding: 10px 16px;
    font-size: 13px;
    background: rgba(0,0,0,.25);
    border-bottom: 1px solid rgba(0,210,200,.12);
    backdrop-filter: blur(8px);
    position: sticky;
    top: 0;
    z-index: 10;
    animation: fadeSlideUp .4s ease both;
  }
  .lm-breadcrumb-link { color: #00d2c8; cursor: pointer; transition: color .2s; }
  .lm-breadcrumb-link:hover { color: #40e8e0; }
  .lm-breadcrumb-sep { margin: 0 6px; color: rgba(0,210,200,.4); }
  .lm-breadcrumb-current { color: #7ab0b8; font-weight: 600; }
  .lm-section {
    border: 1px solid rgba(0,210,200,.18);
    margin-bottom: 8px;
    border-radius: 12px;
    overflow: hidden;
    background: linear-gradient(160deg, rgba(12,28,45,.96) 0%, rgba(7,18,32,.98) 100%);
    box-shadow: 0 4px 24px rgba(0,0,0,.5), 0 0 40px rgba(0,150,160,.05), inset 0 1px 0 rgba(0,210,200,.07);
    animation: cardIn .5s cubic-bezier(.16,1,.3,1) both;
    backdrop-filter: blur(12px);
  }
  .lm-section:nth-child(1) { animation-delay:.05s; }
  .lm-section:nth-child(2) { animation-delay:.1s; }
  .lm-section:nth-child(3) { animation-delay:.15s; }
  .lm-section:nth-child(4) { animation-delay:.2s; }
  .lm-section:nth-child(5) { animation-delay:.25s; }
  .lm-shimmer-line {
    height: 2px;
    background: linear-gradient(90deg, transparent, #00d2c8, #48cae4, #00d2c8, transparent);
    background-size: 200% auto;
    animation: shimmer 3.5s linear infinite;
  }
  .lm-section-header {
    background: linear-gradient(90deg, rgba(0,160,155,.28) 0%, rgba(0,120,175,.18) 100%);
    border-bottom: 1px solid rgba(0,210,200,.15);
    padding: 10px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    user-select: none;
    transition: background .2s;
  }
  .lm-section-header:hover {
    background: linear-gradient(90deg, rgba(0,160,155,.38) 0%, rgba(0,120,175,.28) 100%);
  }
  .lm-section-title {
    font-size: 13px;
    font-weight: 700;
    color: #e8f4f6;
    letter-spacing: .03em;
  }
  .lm-toggle-btn {
    width: 22px; height: 22px;
    border-radius: 6px;
    background: rgba(0,210,200,.15);
    border: 1px solid rgba(0,210,200,.3);
    color: #00d2c8;
    font-size: 15px;
    font-weight: 700;
    display: flex; align-items: center; justify-content: center;
    transition: all .2s;
    flex-shrink: 0;
  }
  .lm-section-header:hover .lm-toggle-btn {
    background: rgba(0,210,200,.25);
    box-shadow: 0 0 10px rgba(0,210,200,.3);
  }

  .lm-section-body {
    padding: 14px 16px;
    background: #c5d7d5;
  }

  .lm-row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 10px;
  }
  .lm-field { display: flex; flex-direction: column; min-width: 60px; }

  .lm-label {
    font-size: 10.5px;
    color: #1a5558;
    margin-bottom: 3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    letter-spacing: .02em;
    font-weight: 600;
  }

  .lm-input-wrap { display: flex; align-items: center; gap: 5px; }

  .lm-input {
    width: 100%;
    padding: 5px 9px;
    border: 1px solid rgba(0,100,95,.28);
    border-radius: 7px;
    font-size: 12px;
    height: 28px;
    box-sizing: border-box;
    background: rgba(255,255,255,.52);
    color: #0b2d30;
    font-family: 'DM Sans', sans-serif;
    font-weight: 500;
    transition: border-color .2s, box-shadow .2s, background .2s;
    outline: none;
  }
  .lm-input:focus {
    border-color: #007a74;
    box-shadow: 0 0 0 3px rgba(0,120,115,.2);
    background: rgba(255,255,255,.72);
    color: #051c20;
  }
  .lm-input:hover:not(:focus) {
    border-color: rgba(0,100,95,.48);
    background: rgba(255,255,255,.62);
  }
  select.lm-input { cursor: pointer; color: #0b2d30; }
  select.lm-input option { background: #ddecea; color: #0b2d30; }

  .lm-check {
    color: #006f6a;
    font-weight: 700;
    font-size: 14px;
    filter: drop-shadow(0 0 3px rgba(0,140,130,.4));
    flex-shrink: 0;
  }
  .lm-input::placeholder { color: rgba(10,55,58,.38); }

  .lm-badge {
    display: inline-block;
    padding: 4px 8px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 600;
  }
  .lm-badge-approved {
    background: rgba(0,120,110,.14);
    border: 1px solid rgba(0,120,110,.32);
    color: #094a47;
  }
  .lm-badge-pending {
    background: rgba(180,100,0,.12);
    border: 1px solid rgba(180,100,0,.28);
    color: #7a3e00;
  }
  .lm-badge-rejected {
    background: rgba(180,40,40,.12);
    border: 1px solid rgba(180,40,40,.28);
    color: #7a1010;
  }

  .lm-stats-grid {
    display: flex;
    gap: 16px;
    margin-bottom: 20px;
    flex-wrap: wrap;
  }
  .lm-stat-card {
    background: rgba(255,255,255,.32);
    border: 1px solid rgba(0,110,105,.22);
    border-radius: 10px;
    padding: 16px 20px;
    min-width: 160px;
    flex: 1;
  }
  .lm-stat-value {
    font-size: 28px;
    font-weight: 700;
    color: #005e5a;
    line-height: 1.2;
  }
  .lm-stat-label {
    font-size: 11px;
    color: #2a7070;
    text-transform: uppercase;
    letter-spacing: .03em;
    margin-top: 4px;
    font-weight: 600;
  }
  .lm-progress-bar {
    height: 6px;
    background: rgba(0,110,105,.15);
    border-radius: 3px;
    overflow: hidden;
    width: 100%;
    margin-top: 8px;
  }
  .lm-progress-fill {
    height: 100%;
    background: linear-gradient(90deg, #00968c, #00c4b8);
    border-radius: 3px;
  }

  .lm-filter-bar {
    display: flex;
    gap: 10px;
    margin-bottom: 16px;
    flex-wrap: wrap;
    align-items: flex-end;
  }
  .lm-action-btn {
    padding: 6px 14px;
    background: rgba(0,110,105,.15);
    border: 1px solid rgba(0,110,105,.3);
    border-radius: 20px;
    color: #094a47;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all .2s;
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }
  .lm-action-btn:hover {
    background: rgba(0,110,105,.26);
    box-shadow: 0 0 8px rgba(0,110,105,.2);
  }
  .lm-action-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }

  .lm-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
  }
  .lm-table th {
    text-align: left;
    padding: 10px 8px;
    color: #1a5558;
    font-weight: 700;
    border-bottom: 1px solid rgba(0,110,105,.25);
    background: rgba(255,255,255,.18);
  }
  .lm-table td {
    padding: 10px 8px;
    color: #0b2d30;
    border-bottom: 1px solid rgba(0,110,105,.1);
  }
  .lm-table tr:hover td {
    background: rgba(255,255,255,.18);
  }

  /* ── Leave Summary Tabs ── */
  .lm-tabs {
    display: flex;
    gap: 4px;
    margin-bottom: 16px;
    border-bottom: 2px solid rgba(0,110,105,.2);
    padding-bottom: 0;
  }
  .lm-tab {
    padding: 7px 16px;
    font-size: 12px;
    font-weight: 600;
    color: #2a7070;
    cursor: pointer;
    border-radius: 8px 8px 0 0;
    border: 1px solid transparent;
    border-bottom: none;
    margin-bottom: -2px;
    transition: all .2s;
    background: transparent;
  }
  .lm-tab:hover { background: rgba(255,255,255,.2); color: #094a47; }
  .lm-tab.active {
    background: rgba(255,255,255,.38);
    border-color: rgba(0,110,105,.25);
    border-bottom-color: #c5d7d5;
    color: #004a46;
  }

  /* ── Year Overview Grid ── */
  .lm-year-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
    margin-bottom: 16px;
  }
  @media (max-width: 900px) { .lm-year-grid { grid-template-columns: repeat(2,1fr); } }
  @media (max-width: 500px) { .lm-year-grid { grid-template-columns: 1fr; } }

  .lm-month-card {
    background: rgba(255,255,255,.28);
    border: 1px solid rgba(0,110,105,.18);
    border-radius: 10px;
    padding: 10px;
    cursor: pointer;
    transition: box-shadow .2s, background .2s;
  }
  .lm-month-card:hover, .lm-month-card.selected {
    background: rgba(255,255,255,.42);
    box-shadow: 0 0 0 2px rgba(0,140,130,.35);
  }
  .lm-month-name {
    font-size: 11px;
    font-weight: 700;
    color: #1a5558;
    margin-bottom: 6px;
    text-transform: uppercase;
    letter-spacing: .04em;
  }
  .lm-month-mini-cal {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 1px;
  }
  .lm-mini-day-hdr {
    font-size: 7.5px;
    text-align: center;
    color: #2a7070;
    font-weight: 700;
    padding: 1px 0;
  }
  .lm-mini-day {
    font-size: 8px;
    text-align: center;
    padding: 2px 1px;
    border-radius: 2px;
    color: #0b2d30;
    line-height: 1.4;
    position: relative;
  }
  .lm-mini-day.holiday {
    background: rgba(220,60,60,.22);
    color: #7a1010;
    font-weight: 700;
  }
  .lm-mini-day.annual {
    background: rgba(0,130,120,.22);
    color: #004a46;
    font-weight: 700;
  }
  .lm-mini-day.sick {
    background: rgba(255,160,0,.22);
    color: #6a3c00;
    font-weight: 700;
  }
  .lm-mini-day.casual {
    background: rgba(80,120,220,.22);
    color: #1a2a7a;
    font-weight: 700;
  }
  .lm-mini-day.weekend {
    color: #5a9090;
  }
  .lm-mini-day.empty { visibility: hidden; }

  .lm-month-badges {
    display: flex; flex-wrap: wrap; gap: 3px; margin-top: 6px;
  }
  .lm-mini-badge {
    font-size: 9px;
    font-weight: 600;
    padding: 1px 5px;
    border-radius: 8px;
  }
  .lm-mini-badge-h { background: rgba(220,60,60,.15); color: #7a1010; border: 1px solid rgba(220,60,60,.25); }
  .lm-mini-badge-a { background: rgba(0,130,120,.15); color: #004a46; border: 1px solid rgba(0,130,120,.25); }
  .lm-mini-badge-s { background: rgba(255,160,0,.15); color: #6a3c00; border: 1px solid rgba(255,160,0,.25); }
  .lm-mini-badge-c { background: rgba(80,120,220,.15); color: #1a2a7a; border: 1px solid rgba(80,120,220,.25); }

  /* Holiday table */
  .lm-holiday-section {
    margin-top: 16px;
  }
  .lm-holiday-table-hdr {
    font-size: 12px;
    font-weight: 700;
    color: #1a5558;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .lm-holiday-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 7px 10px;
    background: rgba(255,255,255,.22);
    border: 1px solid rgba(0,110,105,.12);
    border-radius: 7px;
    margin-bottom: 5px;
    transition: background .15s;
  }
  .lm-holiday-row:hover { background: rgba(255,255,255,.36); }
  .lm-holiday-date-box {
    min-width: 46px;
    text-align: center;
    background: rgba(220,60,60,.18);
    border: 1px solid rgba(220,60,60,.3);
    border-radius: 6px;
    padding: 4px 6px;
  }
  .lm-holiday-date-day { font-size: 15px; font-weight: 700; color: #7a1010; line-height: 1; }
  .lm-holiday-date-mo  { font-size: 9px; font-weight: 600; color: #a04040; text-transform: uppercase; }
  .lm-holiday-name { font-size: 12px; font-weight: 600; color: #0b2d30; flex: 1; }
  .lm-holiday-type-badge {
    font-size: 10px; font-weight: 600; padding: 2px 8px; border-radius: 10px;
  }
  .lm-holiday-type-national { background: rgba(220,60,60,.14); color: #7a1010; border: 1px solid rgba(220,60,60,.28); }
  .lm-holiday-type-optional { background: rgba(80,120,220,.14); color: #1a2a7a; border: 1px solid rgba(80,120,220,.28); }
  .lm-holiday-type-restricted { background: rgba(255,160,0,.14); color: #6a3c00; border: 1px solid rgba(255,160,0,.28); }

  /* Leave detail table */
  .lm-leave-detail-row {
    display: grid;
    grid-template-columns: 90px 90px 60px 1fr 90px;
    gap: 8px;
    padding: 7px 10px;
    align-items: center;
    background: rgba(255,255,255,.22);
    border: 1px solid rgba(0,110,105,.12);
    border-radius: 7px;
    margin-bottom: 5px;
    font-size: 12px;
    color: #0b2d30;
    transition: background .15s;
  }
  .lm-leave-detail-row:hover { background: rgba(255,255,255,.36); }
  .lm-leave-detail-row.hdr {
    background: rgba(255,255,255,.14);
    font-weight: 700;
    font-size: 11px;
    color: #1a5558;
  }

  /* Year summary strip */
  .lm-year-strip {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    margin-bottom: 16px;
  }
  .lm-year-strip-card {
    background: rgba(255,255,255,.3);
    border: 1px solid rgba(0,110,105,.2);
    border-radius: 8px;
    padding: 10px 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 80px;
    flex: 1;
  }
  .lm-year-strip-val { font-size: 22px; font-weight: 700; }
  .lm-year-strip-lbl { font-size: 9.5px; font-weight: 600; text-transform: uppercase; letter-spacing: .03em; margin-top: 2px; }
`;

const PARTICLES = Array.from({ length: 18 }, (_, i) => ({
  id: i,
  size: Math.random() * 4 + 2,
  left: Math.random() * 100,
  dur: Math.random() * 12 + 8,
  delay: Math.random() * 10,
  dx: (Math.random() - 0.5) * 100,
}));

// ── Data ────────────────────────────────────────────────────────────────────

const leaveSummaryData = {
  employeeName: "Dipanita Das",
  employeeCode: "E226",
  leaveBalance: {
    annual: { total: 18, used: 12, remaining: 6 },
    sick: { total: 12, used: 5, remaining: 7 },
    casual: { total: 10, used: 8, remaining: 2 },
    maternity: { total: 84, used: 0, remaining: 84 },
    total: { total: 124, used: 25, remaining: 99 },
  },
  year: "2026",
};

// Public holidays 2024 (India - typical)
const holidays2026 = [
  { date: "2026-01-01", name: "New Year", type: "National" },
  { date: "2026-01-26", name: "Republic Day", type: "National" },
  { date: "2026-03-03", name: "Holi", type: "National" },
  { date: "2026-03-21", name: "Eid-ul-Fitr", type: "National" },
  { date: "2026-04-15", name: "Bengali New Year", type: "National" },
  { date: "2026-05-27", name: "Bakra Eid", type: "National" },
  { date: "2026-06-26", name: "Muharram", type: "National" },
  { date: "2026-08-15", name: "Independence Day", type: "National" },
  { date: "2026-08-28", name: "Raksha Bandhan", type: "National" },
  { date: "2026-10-02", name: "Gandhi Jayanti", type: "National" },
  { date: "2026-10-18", name: "Durga Puja", type: "National" },
  { date: "2026-10-19", name: "Durga Puja", type: "National" },
  { date: "2026-10-20", name: "Durga Puja", type: "National" },
  { date: "2026-10-21", name: "Durga Puja", type: "National" },
  { date: "2026-10-25", name: "Laxmi Puja", type: "National" },
  { date: "2026-11-08", name: "Diwali", type: "National" },
  { date: "2026-11-11", name: "Bhai Dooj", type: "National" },
  { date: "2026-12-25", name: "Christmas Day", type: "National" },
];

// Helpers
const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const DAYS_SHORT = ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"];

function getFirstDayOffset(year: number, month: number) {
  const d = new Date(year, month, 1).getDay();
  return d === 0 ? 6 : d - 1;
}
function getDaysInMonth(year: number, month: number) {
  return new Date(year, month + 1, 0).getDate();
}
function parseDate(s: string) {
  return new Date(s);
}
function fmt(d: Date, fmt: "day" | "mon" | "full") {
  if (fmt === "day") return d.getDate();
  if (fmt === "mon") return MONTHS[d.getMonth()].slice(0, 3);
  return d.toLocaleDateString("en-GB");
}

function dayClass(year: number, month: number, day: number) {
  const dateStr = `${year}-${String(month + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
  const dow = new Date(year, month, day).getDay();
  if (dow === 0 || dow === 6) return "weekend";
  if (holidays2026.some((h) => h.date === dateStr)) return "holiday";
  return "";
}

// Mini calendar for a given month
function MiniCal({
  year,
  month,
  selected,
  onClick,
}: {
  year: number;
  month: number;
  selected: boolean;
  onClick: () => void;
}) {
  const offset = getFirstDayOffset(year, month);
  const days = getDaysInMonth(year, month);
  const holidayCount = holidays2026.filter((h) => {
    const d = parseDate(h.date);
    return d.getFullYear() === year && d.getMonth() === month;
  }).length;

  return (
    <div
      className={`lm-month-card ${selected ? "selected" : ""}`}
      onClick={onClick}
    >
      <div className="lm-month-name">
        {MONTHS[month]} {year}
      </div>
      <div className="lm-month-mini-cal">
        {DAYS_SHORT.map((d) => (
          <div key={d} className="lm-mini-day-hdr">
            {d}
          </div>
        ))}
        {Array(offset)
          .fill(null)
          .map((_, i) => (
            <div key={`e${i}`} className="lm-mini-day empty">
              ·
            </div>
          ))}
        {Array(days)
          .fill(null)
          .map((_, i) => {
            const cls = dayClass(year, month, i + 1);
            return (
              <div key={i} className={`lm-mini-day ${cls}`}>
                {i + 1}
              </div>
            );
          })}
      </div>
      <div className="lm-month-badges">
        {holidayCount > 0 && (
          <span className="lm-mini-badge lm-mini-badge-h">
            🎉 {holidayCount}H
          </span>
        )}
      </div>
    </div>
  );
}

// ── Tab: Year Calendar Overview ──────────────────────────────────────────────
function YearCalendarTab() {
  const [selMonth, setSelMonth] = React.useState<number | null>(null);
  const year = 2024;

  const totalHolidays = holidays2026.length;
  const nationalHolidays = holidays2026.filter(
    (h) => h.type === "National",
  ).length;
  const optRestHolidays = holidays2026.filter(
    (h) => h.type !== "National",
  ).length;

  return (
    <div>
      <div className="lm-year-strip">
        {[
          { val: totalHolidays, lbl: "Total Holidays", color: "#7a1010" },
          { val: nationalHolidays, lbl: "National Holidays", color: "#004a46" },
          {
            val: optRestHolidays,
            lbl: "Optional/Restricted",
            color: "#6a3c00",
          },
          { val: 52 * 2, lbl: "Weekends", color: "#2a7070" },
        ].map(({ val, lbl, color }) => (
          <div key={lbl} className="lm-year-strip-card">
            <div className="lm-year-strip-val" style={{ color }}>
              {val}
            </div>
            <div className="lm-year-strip-lbl" style={{ color }}>
              {lbl}
            </div>
          </div>
        ))}
      </div>

      <div
        style={{
          display: "flex",
          gap: 12,
          flexWrap: "wrap",
          marginBottom: 12,
          fontSize: 11,
          fontWeight: 600,
        }}
      >
        {[
          { cls: "lm-mini-day holiday", label: "Public Holiday" },
          { cls: "lm-mini-day weekend", label: "Weekend" },
        ].map(({ cls, label }) => (
          <div
            key={label}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 5,
              color: "#1a5558",
            }}
          >
            <div
              style={{ width: 14, height: 14, borderRadius: 3 }}
              className={cls}
            >
              ·
            </div>
            {label}
          </div>
        ))}
      </div>

      <div className="lm-year-grid">
        {MONTHS.map((_, mi) => (
          <MiniCal
            key={mi}
            year={year}
            month={mi}
            selected={selMonth === mi}
            onClick={() => setSelMonth(selMonth === mi ? null : mi)}
          />
        ))}
      </div>

      {selMonth !== null && (
        <div style={{ marginTop: 8 }}>
          <div className="lm-holiday-section">
            <div className="lm-holiday-table-hdr">
              🎉 Public Holidays — {MONTHS[selMonth]} {year}
            </div>
            {holidays2026.filter(
              (h) => parseDate(h.date).getMonth() === selMonth,
            ).length === 0 ? (
              <div style={{ fontSize: 12, color: "#2a7070", padding: "8px 0" }}>
                No public holidays this month.
              </div>
            ) : (
              holidays2026
                .filter((h) => parseDate(h.date).getMonth() === selMonth)
                .map((h) => {
                  const d = parseDate(h.date);
                  return (
                    <div key={h.date} className="lm-holiday-row">
                      <div className="lm-holiday-date-box">
                        <div className="lm-holiday-date-day">
                          {fmt(d, "day")}
                        </div>
                        <div className="lm-holiday-date-mo">
                          {fmt(d, "mon")}
                        </div>
                      </div>
                      <div className="lm-holiday-name">{h.name}</div>
                      <span
                        className={`lm-holiday-type-badge lm-holiday-type-${h.type.toLowerCase()}`}
                      >
                        {h.type}
                      </span>
                      <span
                        style={{
                          fontSize: 11,
                          color: "#2a7070",
                          fontWeight: 600,
                        }}
                      >
                        {
                          [
                            "Sunday",
                            "Monday",
                            "Tuesday",
                            "Wednesday",
                            "Thursday",
                            "Friday",
                            "Saturday",
                          ][d.getDay()]
                        }
                      </span>
                    </div>
                  );
                })
            )}
          </div>
        </div>
      )}
    </div>
  );
}

// ── Tab: All Holidays List ───────────────────────────────────────────────────
function HolidaysListTab() {
  const [filter, setFilter] = React.useState("All");
  const filtered =
    filter === "All"
      ? holidays2026
      : holidays2026.filter((h) => h.type === filter);
  return (
    <div>
      <div
        style={{ display: "flex", gap: 6, marginBottom: 12, flexWrap: "wrap" }}
      >
        {["All", "National", "Optional", "Restricted"].map((f) => (
          <span
            key={f}
            className="lm-action-btn"
            style={{
              background: filter === f ? "rgba(0,110,105,.3)" : undefined,
            }}
            onClick={() => setFilter(f)}
          >
            {f}
          </span>
        ))}
        <span
          style={{
            marginLeft: "auto",
            fontSize: 11,
            color: "#2a7070",
            fontWeight: 600,
            alignSelf: "center",
          }}
        >
          {filtered.length} holidays in{" "}
          {filter === "All" ? "year" : filter.toLowerCase()} category
        </span>
      </div>

      {MONTHS.map((mon, mi) => {
        const mHols = filtered.filter(
          (h) => parseDate(h.date).getMonth() === mi,
        );
        if (mHols.length === 0) return null;
        return (
          <div key={mi} style={{ marginBottom: 12 }}>
            <div
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "#1a5558",
                marginBottom: 6,
                paddingBottom: 4,
                borderBottom: "1px solid rgba(0,110,105,.2)",
              }}
            >
              📅 {mon}
            </div>
            {mHols.map((h) => {
              const d = parseDate(h.date);
              return (
                <div key={h.date} className="lm-holiday-row">
                  <div className="lm-holiday-date-box">
                    <div className="lm-holiday-date-day">{fmt(d, "day")}</div>
                    <div className="lm-holiday-date-mo">{fmt(d, "mon")}</div>
                  </div>
                  <div style={{ flex: 1 }}>
                    <div className="lm-holiday-name">{h.name}</div>
                    <div
                      style={{ fontSize: 10, color: "#2a7070", marginTop: 2 }}
                    >
                      {
                        [
                          "Sunday",
                          "Monday",
                          "Tuesday",
                          "Wednesday",
                          "Thursday",
                          "Friday",
                          "Saturday",
                        ][d.getDay()]
                      }
                    </div>
                  </div>
                  <span
                    className={`lm-holiday-type-badge lm-holiday-type-${h.type.toLowerCase()}`}
                  >
                    {h.type}
                  </span>
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}

// ── Tabbed Leave Summary ─────────────────────────────────────────────────────
function LeaveSummarySection() {
  const [tab, setTab] = React.useState<"overview" | "holidays">(
    "overview",
  );
  const tabs = [
    { key: "overview", label: "📅 Year Calendar Overview" },
    { key: "holidays", label: "🎉 All Holidays" },
  ] as const;

  return (
    <div className="lm-section">
      <div className="lm-shimmer-line" />
      <div className="lm-section-header" style={{ cursor: "default" }}>
        <span className="lm-section-title">
          Leave Summary — {leaveSummaryData.employeeName} (
          {leaveSummaryData.employeeCode}) · Year {leaveSummaryData.year}
        </span>
        <span className="lm-toggle-btn">−</span>
      </div>
      <div className="lm-section-body">
        <div className="lm-tabs">
          {tabs.map((t) => (
            <div
              key={t.key}
              className={`lm-tab ${tab === t.key ? "active" : ""}`}
              onClick={() => setTab(t.key)}
            >
              {t.label}
            </div>
          ))}
        </div>

        {tab === "overview" && <YearCalendarTab />}
        {tab === "holidays" && <HolidaysListTab />}

        <div className="lm-row" style={{ marginTop: 16 }}>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "8px",
              width: "100%",
            }}
          >
            <span className="lm-action-btn">📊 Export Report</span>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── Rest of page ─────────────────────────────────────────────────

const leaveTypes = [
  "Annual Leave",
  "Sick Leave",
  "Casual Leave",
  "Maternity Leave",
  "Paternity Leave",
  "Bereavement Leave",
];
const statusTypes = ["All", "Pending", "Approved", "Rejected"];
const departments = [
  "All",
  "Engineering",
  "HR",
  "Finance",
  "Marketing",
  "Operations",
];

interface ColSectionState {
  open: boolean;
}
interface ColSectionProps {
  title: string;
  defaultOpen?: boolean;
  children?: React.ReactNode;
}

class CollapsibleSection extends React.Component<
  ColSectionProps,
  ColSectionState
> {
  constructor(props: ColSectionProps) {
    super(props);
    this.state = { open: props.defaultOpen ?? false };
  }
  toggle = () => this.setState((s) => ({ open: !s.open }));
  render() {
    const { title, children } = this.props;
    const { open } = this.state;
    return (
      <div className="lm-section">
        <div className="lm-shimmer-line" />
        <div className="lm-section-header" onClick={this.toggle}>
          <span className="lm-section-title">{title}</span>
          <span className="lm-toggle-btn">{open ? "−" : "+"}</span>
        </div>
        {open && <div className="lm-section-body">{children}</div>}
      </div>
    );
  }
}

interface FieldProps {
  label: string;
  value?: string;
  width?: string;
  type?: string;
  verified?: boolean;
  isSelect?: boolean;
  options?: string[];
  onChange?: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

function Field({
  label,
  value = "",
  width = "auto",
  type = "text",
  verified,
  isSelect,
  options = [],
  onChange
}: FieldProps) {
  return (
    <div className="lm-field" style={{ width }}>
      <label className="lm-label">{label}</label>
      <div className="lm-input-wrap">
        {isSelect ? (
          <select 
            className="lm-input" 
            value={value}
            onChange={onChange}
          >
            {options.map((o) => (
              <option key={o} value={o}>{o}</option>
            ))}
          </select>
        ) : (
          <input 
            className="lm-input" 
            type={type} 
            value={value}
            onChange={onChange}
          />
        )}
        {verified && <span className="lm-check">✓</span>}
      </div>
    </div>
  );
}

function Row({ children }: { children: React.ReactNode }) {
  return <div className="lm-row">{children}</div>;
}

function Badge({ status }: { status: string }) {
  const cls =
    status.toLowerCase() === "approved"
      ? "lm-badge-approved"
      : status.toLowerCase() === "pending"
        ? "lm-badge-pending"
        : "lm-badge-rejected";
  return <span className={`lm-badge ${cls}`}>{status}</span>;
}

// Define the leave state interface matching your reducer pattern
interface LeaveState {
  records: LeaveRecord[];
  filteredRecords: LeaveRecord[];
  selectedLeave: LeaveRecord | null;
  filters: any;
  loading: boolean;
  error: string | null;
}

interface LeaveManagementPageProps {
  GetLeaveDetails: (employeeCode?: string) => Promise<any>;
  ManageLeave: (leaveData: ManageLeaveRequest) => Promise<any>;
  leaveRecords: LeaveRecord[];
  loading: boolean;
  error: string | null;
}

interface LeaveManagementPageState {
  pending: number;
  approved: number;
  rejected: number;
  requests: any[];
  filteredRequests: any[];
  employeeCode: string;
  employeeName: string;
  isLeavePopupOpen: boolean;
  popupMode: 'apply' | 'edit' | 'view';
  selectedLeave: LeaveRecord | null;
  isSubmitting: boolean;
  filters: {
    department: string;
    leaveType: string;
    status: string;
    fromDate: string;
    toDate: string;
  };
}

class LeaveManagementPage extends PureComponent<LeaveManagementPageProps, LeaveManagementPageState> {
  constructor(props: LeaveManagementPageProps) {
    super(props);
    
    // Get employee code and name from session storage
    const employeeCodeFromStorage = sessionStorage.getItem('employeeCode') || '';
    const employeeNameFromStorage = sessionStorage.getItem('employeeName') || 'Employee';
    
    this.state = {
      pending: 0,
      approved: 0,
      rejected: 0,
      requests: [],
      filteredRequests: [],
      employeeCode: employeeCodeFromStorage,
      employeeName: employeeNameFromStorage,
      isLeavePopupOpen: false,
      popupMode: 'apply',
      selectedLeave: null,
      isSubmitting: false,
      filters: {
        department: "All",
        leaveType: "All",
        status: "All",
        fromDate: "",
        toDate: ""
      }
    };
  }

  componentDidMount() {
    // Update leaveSummaryData with the actual employee name and code from session storage
    if (this.state.employeeCode) {
      leaveSummaryData.employeeCode = this.state.employeeCode;
      leaveSummaryData.employeeName = this.state.employeeName;
      this.fetchLeaveDetails();
    }
  }

  componentDidUpdate(prevProps: LeaveManagementPageProps) {
    if (prevProps.leaveRecords !== this.props.leaveRecords && this.props.leaveRecords.length > 0) {
      this.populateLeaveData(this.props.leaveRecords);
    }
  }

  fetchLeaveDetails = async () => {
    const { employeeCode } = this.state;
    if (!employeeCode) {
      console.warn('No employee code found in session storage');
      return;
    }
    const result = await this.props.GetLeaveDetails(employeeCode);
    
    if (result?.records) {
      this.populateLeaveData(result.records);
    }
  };

  populateLeaveData = (records: LeaveRecord[]) => {
    const pending = records.filter(r => r.status?.toLowerCase() === "pending").length;
    const approved = records.filter(r => r.status?.toLowerCase() === "approved").length;
    const rejected = records.filter(r => r.status?.toLowerCase() === "rejected").length;

    const requests = records.map(record => ({
      id: record.leaveRequestId || `LV${record.id}`,
      employee: record.employeeName || this.state.employeeName,
      type: record.leaveType,
      fromDate: record.fromDate,
      toDate: record.toDate,
      days: record.days || this.calculateDays(record.fromDate, record.toDate),
      status: record.status,
      appliedOn: record.appliedOn || record.createdOn,
      reason: record.reason,
      originalRecord: record
    }));

    this.setState({
      pending,
      approved,
      rejected,
      requests,
      filteredRequests: requests
    });
  };

  calculateDays = (fromDate: string, toDate: string): number => {
    const from = new Date(fromDate);
    const to = new Date(toDate);
    const diffTime = Math.abs(to.getTime() - from.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
    return diffDays;
  };

  handleFilterChange = (key: string, value: string) => {
    this.setState(prev => ({
      filters: {
        ...prev.filters,
        [key]: value
      }
    }), () => {
      // Apply filters automatically when any filter changes
      this.applyFilters();
    });
  };

  applyFilters = () => {
    const { filters, requests } = this.state;
    
    const filtered = requests.filter(request => {
      let matches = true;
      
      // Filter by Leave Type
      if (filters.leaveType !== "All") {
        matches = matches && request.type === filters.leaveType;
      }
      
      // Filter by Status
      if (filters.status !== "All") {
        matches = matches && request.status === filters.status;
      }
      
      // Filter by From Date
      if (filters.fromDate) {
        const requestFromDate = new Date(request.fromDate);
        const filterFromDate = new Date(filters.fromDate);
        matches = matches && requestFromDate >= filterFromDate;
      }
      
      // Filter by To Date
      if (filters.toDate) {
        const requestToDate = new Date(request.toDate);
        const filterToDate = new Date(filters.toDate);
        matches = matches && requestToDate <= filterToDate;
      }
      
      return matches;
    });
    
    // Update counts based on filtered results
    const pending = filtered.filter(r => r.status?.toLowerCase() === "pending").length;
    const approved = filtered.filter(r => r.status?.toLowerCase() === "approved").length;
    const rejected = filtered.filter(r => r.status?.toLowerCase() === "rejected").length;
    
    this.setState({
      filteredRequests: filtered,
      pending,
      approved,
      rejected
    });
  };

  handleResetFilters = () => {
    this.setState({
      filters: {
        department: "All",
        leaveType: "All",
        status: "All",
        fromDate: "",
        toDate: ""
      },
      filteredRequests: this.state.requests
    }, () => {
      // Recalculate stats based on all requests
      const { requests } = this.state;
      const pending = requests.filter(r => r.status?.toLowerCase() === "pending").length;
      const approved = requests.filter(r => r.status?.toLowerCase() === "approved").length;
      const rejected = requests.filter(r => r.status?.toLowerCase() === "rejected").length;
      
      this.setState({
        pending,
        approved,
        rejected
      });
    });
  };

  handleApplyLeave = () => {
    console.log('Opening leave popup');
    this.setState({
      isLeavePopupOpen: true,
      popupMode: 'apply',
      selectedLeave: null
    });
  };

  handleEditLeave = (request: any) => {
    console.log('Editing leave:', request);
    this.setState({
      isLeavePopupOpen: true,
      popupMode: 'edit',
      selectedLeave: request.originalRecord
    });
  };

  handleViewLeave = (request: any) => {
    console.log('Viewing leave:', request);
    this.setState({
      isLeavePopupOpen: true,
      popupMode: 'view',
      selectedLeave: request.originalRecord
    });
  };

  handleDeleteLeave = async (request: any) => {
    if (!window.confirm(`Are you sure you want to delete the leave request for ${request.employee}?`)) {
      return;
    }
    
    this.setState({ isSubmitting: true });
    
    try {
      const leaveData: ManageLeaveRequest = {
        appliedOn: new Date().toISOString().split('T')[0],
        days: request.days,
        employeeCode: request.originalRecord.employeeCode || this.state.employeeCode,
        fromDate: request.fromDate,
        leaveRequestId: request.originalRecord.leaveRequestId || request.id,
        leaveType: request.type,
        operation: "D", // D for Delete
        status: request.status,
        toDate: request.toDate,
        updatedBy: "manager@example.com" // Replace with actual logged-in user
      };

      console.log('Deleting leave with operation: D', leaveData);
      
      const result = await this.props.ManageLeave(leaveData);
      
      if (result.success) {
        alert(`Leave request ${request.id} deleted successfully!`);
        this.fetchLeaveDetails(); // Refresh data
      } else {
        alert(`Failed to delete request: ${result.message}`);
      }
    } catch (error) {
      console.error('Error deleting request:', error);
      alert('Failed to delete request. Please try again.');
    } finally {
      this.setState({ isSubmitting: false });
    }
  };

  handlePopupClose = () => {
    console.log('Closing popup');
    this.setState({ isLeavePopupOpen: false });
  };

  handlePopupSuccess = () => {
    console.log('Popup success, refreshing data');
    // Refresh leave data after successful submission
    this.fetchLeaveDetails();
    this.setState({ isLeavePopupOpen: false });
  };

  getOperationLabel = (mode: string) => {
    switch(mode) {
      case 'apply': return 'I (Insert)';
      case 'edit': return 'U (Update)';
      case 'view': return 'View';
      default: return '';
    }
  };

  render() {
    const { 
      pending, 
      approved, 
      rejected, 
      filteredRequests, 
      employeeCode, 
      employeeName,
      isLeavePopupOpen, 
      popupMode, 
      selectedLeave,
      isSubmitting,
      filters
    } = this.state;
    const { loading, error } = this.props;

    console.log('Rendering with isLeavePopupOpen:', isLeavePopupOpen);
    console.log('Filtered requests count:', filteredRequests.length);

    const leaveRequestsData = {
      pending,
      approved,
      rejected,
      requests: filteredRequests
    };

    return (
      <>
        <style>{globalStyles}</style>
        <div className="lm-page">
          <div
            style={{
              position: "fixed",
              top: "5%",
              left: "8%",
              width: 420,
              height: 420,
              borderRadius: "50%",
              background:
                "radial-gradient(circle, rgba(0,160,155,.2) 0%, transparent 68%)",
              animation: "orbPulse1 11s ease-in-out infinite",
              pointerEvents: "none",
              zIndex: 0,
            }}
          />
          <div
            style={{
              position: "fixed",
              bottom: "8%",
              right: "6%",
              width: 500,
              height: 500,
              borderRadius: "50%",
              background:
                "radial-gradient(circle, rgba(0,120,175,.15) 0%, transparent 68%)",
              animation: "orbPulse2 15s ease-in-out infinite",
              pointerEvents: "none",
              zIndex: 0,
            }}
          />
          <div className="lm-grid-bg" />
          {PARTICLES.map((p) => (
            <div
              key={p.id}
              className="lm-particle"
              style={{
                width: p.size,
                height: p.size,
                left: `${p.left}%`,
                bottom: -p.size,
                ["--dur" as any]: `${p.dur}s`,
                ["--delay" as any]: `${p.delay}s`,
                ["--dx" as any]: `${p.dx}px`,
              }}
            />
          ))}

          <div className="lm-breadcrumb">
            <span className="lm-breadcrumb-current">Leave Management</span>
            {employeeCode && (
              <span style={{ marginLeft: 16, color: '#00d2c8', fontSize: 11 }}>
                Employee: {employeeName} ({employeeCode})
              </span>
            )}
            {loading && <span style={{ marginLeft: 16, color: '#00d2c8', fontSize: 11 }}>Loading...</span>}
            {isSubmitting && <span style={{ marginLeft: 16, color: '#ffaa00', fontSize: 11 }}>Submitting...</span>}
            {error && <span style={{ marginLeft: 16, color: '#ff6b6b', fontSize: 11 }}>Error: {error}</span>}
          </div>

          <div className="lm-content">
            {/* Enhanced Leave Summary */}
            <LeaveSummarySection />

            {/* Leave Requests */}
            <CollapsibleSection title="Leave Requests" defaultOpen={true}>
              <Row>
                <div className="lm-stats-grid">
                  {[
                    { val: leaveRequestsData.pending, label: "Pending Requests" },
                    { val: leaveRequestsData.approved, label: "Approved" },
                    { val: leaveRequestsData.rejected, label: "Rejected" },
                    { val: leaveRequestsData.requests.length, label: "Filtered Results" },
                  ].map(({ val, label }) => (
                    <div key={label} className="lm-stat-card">
                      <div className="lm-stat-value">{val}</div>
                      <div className="lm-stat-label">{label}</div>
                    </div>
                  ))}
                </div>
              </Row>

              <Row>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    marginBottom: "8px",
                  }}
                >
                  <span
                    className="lm-section-title"
                    style={{ fontSize: "14px" }}
                  >
                    Filter Requests
                  </span>
                  <span
                    className="lm-action-btn"
                    style={{
                      background: "rgba(0,160,155,.25)",
                      padding: "8px 18px",
                      fontSize: "13px",
                      fontWeight: "700",
                      cursor: "pointer"
                    }}
                    onClick={this.handleApplyLeave}
                  >
                    ➕ Apply for New Leave
                  </span>
                </div>
              </Row>

              <Row>
                <Field
                  label="Leave Type"
                  value={filters.leaveType}
                  width="20%"
                  isSelect
                  options={["All", ...leaveTypes]}
                  onChange={(e) => this.handleFilterChange('leaveType', e.target.value)}
                />
                <Field
                  label="Status"
                  value={filters.status}
                  width="15%"
                  isSelect
                  options={statusTypes}
                  onChange={(e) => this.handleFilterChange('status', e.target.value)}
                />
                <Field 
                  label="From Date" 
                  value={filters.fromDate} 
                  width="15%" 
                  type="date" 
                  onChange={(e) => this.handleFilterChange('fromDate', e.target.value)}
                />
                <Field 
                  label="To Date" 
                  value={filters.toDate} 
                  width="15%" 
                  type="date" 
                  onChange={(e) => this.handleFilterChange('toDate', e.target.value)}
                />
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-end",
                    gap: "8px",
                  }}
                >
                  <span className="lm-action-btn" onClick={this.applyFilters}>🔍 Search</span>
                  <span className="lm-action-btn" onClick={this.handleResetFilters}>↻ Reset</span>
                </div>
              </Row>
              
              {loading ? (
                <div style={{ textAlign: 'center', padding: 40, color: '#00d2c8' }}>
                  Loading leave requests...
                </div>
              ) : (
                <table className="lm-table">
                  <thead>
                    <tr>
                      {[
                        "Request ID",
                        "Employee",
                        "Leave Type",
                        "From Date",
                        "To Date",
                        "Days",
                        "Status",
                        "Applied On",
                        "Reason",
                        "Actions",
                      ].map((h) => (
                        <th key={h}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {leaveRequestsData.requests.length === 0 ? (
                      <tr>
                        <td colSpan={10} style={{ textAlign: 'center', padding: 20, color: '#2a7070' }}>
                          No leave requests match your filters
                        </td>
                      </tr>
                    ) : (
                      leaveRequestsData.requests.map((r) => (
                        <tr key={r.id}>
                          <td style={{ color: "#005e5a", fontWeight: "700" }}>
                            {r.id}
                          </td>
                          <td>{r.employee}</td>
                          <td>{r.type}</td>
                          <td>
                            {new Date(r.fromDate).toLocaleDateString("en-GB")}
                          </td>
                          <td>{new Date(r.toDate).toLocaleDateString("en-GB")}</td>
                          <td style={{ fontWeight: "700", color: "#0b2d30" }}>
                            {r.days}
                          </td>
                          <td>
                            <Badge status={r.status} />
                          </td>
                          <td>
                            {new Date(r.appliedOn).toLocaleDateString("en-GB")}
                          </td>
                          <td
                            style={{
                              maxWidth: "150px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {r.reason}
                          </td>
                          <td>
                            <div style={{ display: "flex", gap: "4px" }}>
                              <span
                                className="lm-action-btn"
                                style={{ padding: "2px 6px", cursor: "pointer" }}
                                onClick={() => this.handleViewLeave(r)}
                                title="View"
                              >
                                👁️
                              </span>
                              <span
                                className="lm-action-btn"
                                style={{ 
                                  padding: "2px 6px",
                                  background: "rgba(0, 160, 155, 0.15)",
                                  cursor: "pointer"
                                }}
                                onClick={() => this.handleEditLeave(r)}
                                title="Edit"
                              >
                                ✏️
                              </span>
                              <span
                                className="lm-action-btn"
                                style={{ 
                                  padding: "2px 6px",
                                  background: "rgba(180,40,40,.12)",
                                  color: "#7a1010",
                                  borderColor: "rgba(180,40,40,.28)",
                                  cursor: "pointer"
                                }}
                                onClick={() => this.handleDeleteLeave(r)}
                                title="Delete (D)"
                              >
                                🗑️
                              </span>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              )}
              
              <Row>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    marginTop: "16px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "11px",
                      color: "#2a7070",
                      fontWeight: 600,
                    }}
                  >
                    Showing {leaveRequestsData.requests.length} of {this.state.requests.length} requests
                  </div>
                  <div style={{ display: "flex", gap: "4px" }}>
                    {["◀", "1", "▶"].map((p, i) => (
                      <span
                        key={i}
                        className="lm-action-btn"
                        style={{
                          padding: "4px 8px",
                          background:
                            p === "1" ? "rgba(0,110,105,.25)" : undefined,
                        }}
                      >
                        {p}
                      </span>
                    ))}
                  </div>
                </div>
              </Row>
            </CollapsibleSection>
          </div>

          {/* Leave Popup */}
          <LeavePopup
            isOpen={isLeavePopupOpen}
            onClose={this.handlePopupClose}
            mode={popupMode}
            leaveData={selectedLeave}
            employeeCode={employeeCode}
            employeeName={employeeName}
            onSubmitSuccess={this.handlePopupSuccess}
          />
        </div>
      </>
    );
  }
}

// Map Redux state to component props
const mapStateToProps = (state: { leave: LeaveState }) => ({
  leaveRecords: state.leave?.records || [],
  loading: state.leave?.loading || false,
  error: state.leave?.error || null
});

const mapDispatchToProps = {
  GetLeaveDetails,
  ManageLeave
};

export default connect(mapStateToProps, mapDispatchToProps)(LeaveManagementPage);